import React, { useState, useEffect, useRef, useCallback } from 'react';
import VectorMap, {
  Layer, Export, Title, Label, Tooltip, Border, Font
} from 'devextreme-react/vector-map';
import { groupBy } from '../../utils/miscUtil';

export default function SIFMap(props) {
  const mapRef = useRef(null);
  const [areaData, setAreaData] = useState();
  const [total, setTotal] = useState(0);
  const [dataSource, setDataSource] = useState('/Basins.json');

  const customizeLayer = useCallback((elements) => {
    if (areaData) {
      elements.forEach((element) => {
        if (element.attribute("BASIN_NAME") in areaData) {
          element.applySettings({
            color: areaData[element.attribute("BASIN_NAME")].color,
          });
        } else {
          element.applySettings({
            color: element.attribute('color'),
          });
        }
      });
    }
  }, [areaData]);

  const customizeTooltip = useCallback( ({ attribute }) => {
    const name = attribute('BASIN_NAME');
    if (areaData) {
      if (name in areaData) {
        return {
          text: `${name}: ${areaData[name].value} events`,
          color: `rgba(${props.accentColorRGB} 1)`,
        };
      }
    }

    return {
      text: `${name}: No events`,
      color: "rgba(20, 77, 109, 1)",
    };
  }, [areaData, props.accentColorRGB])

  useEffect(() => {
    if (!props.data) {
      return
    }
    if (!props.data.length) {
      return
    }
    var fd = groupBy(props.data, 'Area/Basin')
    let fd1 = Object.keys(fd).map((key) => ({name: key, value: fd[key].length}));
    const max=Math.max(...fd1.map(o => o.value))/1
    var t = 0;
    for (const key in fd) {
      fd[key].value = fd[key].length;
      t=t+fd[key].length;
      fd[key].color = `rgba(${props.accentColorRGB} ${0.5+(fd[key].length/max)/2})`
    }
    setAreaData({...fd});
    setTotal(t);
    setDataSource(null)
  }, [props.data, props.accentColorRGB]);

  useEffect(() => {
    if (dataSource === null) {
      setDataSource('/Basins.json')
    }
  }, [dataSource]);

  return (
    <div>
      {true && <VectorMap
        ref={mapRef}
        id="vector-map"
        zoomFactor={10}
        center={[-100,37]}
        wheelEnabled={false}
      >
        <Title
          text={props.title +" ("+total.toString()+")"}
        ></Title>
        <Layer
          type="area"
          dataSource={dataSource}
          color="rgba(86, 227, 159, 0.5)"
          customize={customizeLayer}
        >
          <Label
            enabled={true}
            dataField="BASIN_NAME"
          ></Label>
        </Layer>
        <Tooltip
          enabled={true}
          customizeTooltip={customizeTooltip}
        >
          <Border visible={true}></Border>
          <Font color="#fff"></Font>
        </Tooltip>
        <Export enabled={true}></Export>
      </VectorMap>}


    </div>
  );
}
